var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"404"}},[_c('div',{staticStyle:{"height":"100px"}}),_c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('notFound.offer')))])]),_c('div',{staticStyle:{"height":"75px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }